export default {
  'Japan': 'JP',
  'United States of America': 'US'
}
